// spm-ts/src/util/notification/actionFunctions/yourTeam.ts
import { NotificationActionService } from '../NotificationActionService'
import { NotificationActionType } from '../notification'
import { trackPendoEvent } from '@/util/helper'
import { RouterRegistry } from '@/util/routerRegistry'
import { PendoEventNames } from '@/types/social-planner'


function handleSocialPlannerReintegrationNotification(data?: any) {
  const router = RouterRegistry.getRouter()
    trackPendoEvent(PendoEventNames.REINTEGRATION_EVENT, {
        ...data
    })
    
    router.push({
      name: 'social-planner-settings-v2',
      params: { location_id: data?.locationId },
      query: {
        tab: 'expired'
      }
    })
}

// Register your team's action handlers
export const registerLeadgenNotificationActions = (store: any) => {
    
    // Social Planner Reintegration Notification
    NotificationActionService.registerAction(NotificationActionType.SocialPlannerReintegration, (data) => {
      handleSocialPlannerReintegrationNotification(data)
    })
}
